import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CtaBanner() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target.querySelector('.reveal-item');
            if (el) el.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/0232c479-757c-417f-9996-0a4bc3a6e43d/8b2d8f8e-9f53-45b8-bca2-d80c28f7878e_compressed_000222222.webp"
          alt="Offre découverte"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/55" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="reveal-item opacity-0 translate-y-6 transition-all duration-1000 max-w-3xl mx-auto text-center"
          style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}
        >
          <span className="inline-block px-4 py-2 text-xs font-medium bg-primary-500 text-background-50 rounded-full mb-6 tracking-wider uppercase border border-primary-400">
            Offre limitée
          </span>

          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-xl md:text-2xl text-primary-300 font-heading mb-3">
            {t('cta.subtitle')}
          </p>
          <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-10 max-w-xl mx-auto">
            {t('cta.desc')}
          </p>

          <Link
            to="/rdv"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base md:text-lg font-medium bg-green-600 text-white hover:bg-green-700 transition-all duration-300 whitespace-nowrap shadow-lg shadow-green-600/25"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg" />
            </div>
            {t('cta.button')}
          </Link>
        </div>
      </div>
    </section>
  );
}